import React from 'react';
import {
  Box,
  Typography,
  Alert,
  FormControlLabel,
  Switch,
  CircularProgress,
  Button
} from '@mui/material';

const UserSecurityTab = ({
  formData,
  systemTwoFactorEnabled,
  twoFactorUpdating,
  passwordChangeUpdating,
  selectedUser,
  handleTwoFactorToggle,
  handleForcePasswordChangeToggle,
  error
}) => {
  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" gutterBottom>
        Two-Factor Authentication
      </Typography>
      
      {!systemTwoFactorEnabled ? (
        <Alert severity="info" sx={{ mb: 2 }}>
          Two-factor authentication is currently disabled system-wide.
        </Alert>
      ) : (
        <>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            When enabled, the user will need to enter a verification code sent to their email
            each time they log in, in addition to their password.
          </Typography>
          
          <Box display="flex" alignItems="center" mb={2}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.twoFactorEnabled}
                  onChange={handleTwoFactorToggle}
                  disabled={twoFactorUpdating}
                />
              }
              label={`Two-factor authentication is ${formData.twoFactorEnabled ? 'enabled' : 'disabled'} for this user`}
            />
            {twoFactorUpdating && <CircularProgress size={20} sx={{ ml: 2 }} />}
          </Box>
        </>
      )}

      <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
        Enforce New Password For Next Login
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        When enabled, the user will be required to change their password the next time they log in.
      </Typography>
      
      <Box display="flex" alignItems="center" mb={2}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.forcePasswordChangeOnLogin}
              onChange={handleForcePasswordChangeToggle}
              disabled={passwordChangeUpdating || formData.role === 'admin'}
            />
          }
          label={
            formData.role === 'admin' 
              ? 'Password change on next login is disabled for admin users' 
              : (formData.forcePasswordChangeOnLogin 
                  ? 'Password change on next login is enabled' 
                  : 'Password change on next login is disabled')
          }
        />
        {passwordChangeUpdating && <CircularProgress size={20} sx={{ ml: 2 }} />}
      </Box>
      
      {/* Test button removed as it's no longer needed */}
      
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default UserSecurityTab;
